module.exports = __webpack_public_path__ + "static/media/LifeRamp.e7a35c46.png";